/**
 * @desc 获取交易主体
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.stockAdjustmentMaster.getTradeCompanyCode.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/stockAdjustmentMaster/getTradeCompanyCode`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
